import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IAlert, IUnreadCount} from '../../../models/IAlert';

interface IAlertState {
    list: IAlert[];
    unread: IUnreadCount;
    isConnected: boolean;
    isModalOpen: boolean;
}

const initialState: IAlertState = {
    list: [],
    unread: {count: 0, has_critical: false},
    isConnected: false,
    isModalOpen: false,
};

export const alertSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        setAlertList: (state, action: PayloadAction<IAlert[]>) => {
            state.list = action.payload;
        },
        addAlert: (state, action: PayloadAction<IAlert>) => {
            // Новый алерт в начало, без дублей
            const exists = state.list.some(a => a.id === action.payload.id);
            if (!exists) state.list.unshift(action.payload);
        },
        markAlertsRead: (state, action: PayloadAction<string[]>) => {
            const ids = new Set(action.payload);
            state.list = state.list.map(a =>
                ids.has(a.id) ? {...a, is_read: true, read_at: new Date().toISOString()} : a
            );
        },
        setUnreadCount: (state, action: PayloadAction<IUnreadCount>) => {
            state.unread = action.payload;
        },
        setAlertConnected: (state, action: PayloadAction<boolean>) => {
            state.isConnected = action.payload;
        },
        openAlertModal: (state) => {
            state.isModalOpen = true;
        },
        closeAlertModal: (state) => {
            state.isModalOpen = false;
        },
    },
});

export const {
    setAlertList, addAlert, markAlertsRead,
    setUnreadCount, setAlertConnected,
    openAlertModal, closeAlertModal,
} = alertSlice.actions;
export default alertSlice.reducer;
